import MarkdownIt from 'markdown-it'
import MdEditor from 'react-markdown-editor-lite'
import styled from 'styled-components'
// 导入编辑器的样式
import 'react-markdown-editor-lite/lib/index.css'

const mdParser = new MarkdownIt(/* Markdown-it options */)

interface PropsType {
  height?: number
  onlyDisplay?: boolean
  value: string | null
  setValue: (value: string) => void
  isEdit: boolean
  propStyle?: Object
}

const MarkdownEditor: React.FC<PropsType> = ({
  isEdit,
  onlyDisplay,
  height,
  value,
  setValue,
  propStyle = {},
}) => {
  const handleEditorChange = ({ html, text }) => {
    if (!text) return
    else setValue(text)
  }
  return (
    <Wrapper>
      {isEdit ? (
        (value || value === '') && (
          <MdEditor
            defaultValue={value}
            style={{ minHeight: '100px', borderRight: 'none', ...propStyle }}
            renderHTML={text => mdParser.render(text)}
            onChange={handleEditorChange}
          />
        )
      ) : onlyDisplay ? (
        value && (
          <MdEditor
            defaultValue={value}
            readOnly
            view={{ html: true, md: false, menu: false }}
            style={{ borderRight: 'none', ...propStyle }}
            renderHTML={text => mdParser.render(text)}
            onChange={handleEditorChange}
          />
        )
      ) : (
        <MdEditor
          defaultValue={value}
          style={{ borderRight: 'none', ...propStyle }}
          renderHTML={text => mdParser.render(text)}
          onChange={handleEditorChange}
        />
      )}
    </Wrapper>
  )
}
export default MarkdownEditor

const Wrapper = styled.div`
  .rc-md-editor {
    border-radius: 8px;
    background: #f7f8fa;
    // border: none;
    min-width: 414px;

    .editor-container > .section {
      border-right: none;
    }
  }
`
